import { render, staticRenderFns } from "./instalaciones.vue?vue&type=template&id=677fff81&scoped=true&"
import script from "./instalaciones.vue?vue&type=script&lang=js&"
export * from "./instalaciones.vue?vue&type=script&lang=js&"
import style0 from "./instalaciones.vue?vue&type=style&index=0&id=677fff81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677fff81",
  null
  
)

export default component.exports